
import { Component, Vue, Watch } from "vue-property-decorator";
import TramiteCardComponent from "@/components/Common/Cards/TramiteCardComponent.vue";
import PortalServiciosHeader from "@/components/Tramites/PortalServiciosHeader.vue";
import categoryService from "@/services/category.service";

interface dataCard {
  id: number | any;
  title?: string;
  description?: string;
  slug?: string;
  tags?: Array<any>;
}

@Component({
  components: {
    PortalServiciosHeader,
    TramiteCardComponent
  }
})
export default class CategoriaTramites extends Vue {
  private pagination: Number = 1;
  private perPage: number = 10;
  private categoryName: String = "";
  private categories: Array<any> = [];
  private selectedCategoryId: number | null = Number(this.$route.params.id);
  private tramites: Array<dataCard> = [];
  private async mounted() {
    await Promise.all([
      this.loadCategories().catch(() => undefined),
      this.loadTramites().catch(() => undefined)
    ]);
  }

  get totalPages() {
    return Math.ceil(this.tramites.length / this.perPage) || 1;
  }

  get paginatedTramites() {
    const start = (Number(this.pagination) - 1) * this.perPage;

    return this.tramites.slice(start, start + this.perPage);
  }

  get categoryOptions() {
    return [
      { label: "Todas las categorías", value: null },
      ...this.categories.map((category: any) => ({
        label: this.formatCategoryName(category.name),
        value: Number(category.id)
      }))
    ];
  }

  private async loadCategories() {
    this.categories = await categoryService.getCategoriasTramites();
  }

  private async loadTramites() {
    const response = await categoryService.getTramitesByCategory(
      Number(this.$route.params.id)
    );

    this.categoryName = response.categoria.name;
    this.tramites = response.tramites.map((x: any) => {
      return {
        id: x.id,
        title: x.name.toUpperCase(),
        description: x.description,
        slug: x.slug,
        tags: x.tags || []
      };
    });
  }

  @Watch("selectedCategoryId")
  private selectedCategoryWatch() {
    if (this.selectedCategoryId === null) {
      this.$router.push("/portal-servicios");
      return;
    }

    if (Number(this.$route.params.id) !== Number(this.selectedCategoryId)) {
      this.goToCategory(this.selectedCategoryId);
    }
  }

  @Watch("$route.params.id")
  private async categoryIdWatch() {
    this.selectedCategoryId = Number(this.$route.params.id);
    this.pagination = 1;
    await this.loadTramites();
  }

  private goToCategory(categoryId: number) {
    const category = this.categories.find(
      (item: any) => Number(item.id) === Number(categoryId)
    );

    if (!category) {
      return;
    }

    this.$router.push(
      `/portal-servicios/categoria/${category.id}/${this.slugify(
        category.name
      )}`
    );
  }

  private formatCategoryName(name: any) {
    return (name || "")
      .toString()
      .replace(/\r\n?/g, "\n")
      .replace(/[ \t]+\n/g, "\n")
      .replace(/\n[ \t]+/g, "\n")
      .trim();
  }

  private slugify(text: any) {
    return (text || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }
}
